import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { useAuthenticationStore } from "../stores/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../api";

export const SwitchRoleDialog = ({ open, setOpen }) => {
  const { user, updateUserInfo } = useAuthenticationStore();
  const [selectedRole, setSelectedRole] = useState("");
  const navigate = useNavigate();
  const ApiClient = useApiClient();

  const handleClose = () => {
    setOpen(false);
  };
  const handleSwitch = async () => {
    try {
      const result = await ApiClient.users.switchActiveRoleAssignment({
        roleAssignment: selectedRole,
      });
      if (result.success) {
        enqueueSnackbar("Successfully switched role.", {
          variant: "success",
          autoHideDuration: 3000,
        });

        const userData = await ApiClient.users.me();
        updateUserInfo(userData);
        handleClose();
        navigate("/");
      } else {
        enqueueSnackbar(result.message || "Failed to switch role", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Switching error:", error);
      enqueueSnackbar("Error switching role. Please try again.", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  useEffect(() => {
    if (user.info.activeContext) {
      const { roleAssignment } = user?.info?.activeContext || {};
      setSelectedRole(roleAssignment?.id);
    }
  }, [user]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Switch role</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="user-role-label">Roles</InputLabel>
          <Select
            labelId="user-role-label"
            label={"Roles"}
            value={selectedRole || ""}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            {user.info.roles.map((roleAssignment) => (
              <MenuItem key={roleAssignment.id} value={roleAssignment.id}>
                {roleAssignment.role.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={handleClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSwitch} variant="contained">
            Switch
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
